import { connect } from 'react-redux';
import FrameworkUtils from 'utils/framework';
import Actions from 'Actions';
import BCCUtils from 'utils/BCC';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import CreditCardRewardsEN from 'components/Content/BeautyInsider/BeautyInsiderModules/CreditCardRewards/locales/CreditCardRewards_en_US';
import CreditCardRewardsFR from 'components/Content/BeautyInsider/BeautyInsiderModules/CreditCardRewards/locales/CreditCardRewards_fr_CA';

const { wrapHOC } = FrameworkUtils;
const { CREDIT_CARD_REWARDS } = BCCUtils.MEDIA_IDS;
const { getLocalisedDataFromResource } = LanguageLocaleUtils;
const fields = null;
const getText = getLocalisedDataFromResource(CreditCardRewardsEN, CreditCardRewardsFR);

const functions = dispatch => ({
    showMediaModal: () =>
        dispatch(
            Actions.showMediaModal({
                isOpen: true,
                mediaId: CREDIT_CARD_REWARDS,
                titleDataAt: 'cc_rewards_modal_title',
                showMediaTitle: true,
                dismissButtonText: getText('modalButton'),
                dismissButtonDataAt: 'cc_rewards_modal_got_it_button',
                modalDataAt: 'cc_rewards_modal'
            })
        )
});

const withCreditCardRewardsProps = wrapHOC(connect(fields, functions));

export {
    withCreditCardRewardsProps, fields, functions
};
